<template>
  <div v-if="fieldDataText.field_name" class="field-input-checkbox form-group">
     <div class="custom-control custom-checkbox smaller-font-content">
      <!-- <input
        type="checkbox"
        :disabled="(!!showDisabled(fieldDataCheckbox))"
        :ref="fieldDataCheckbox.field_name"
        :id="fieldDataCheckbox.field_name"
        :name="fieldDataCheckbox.field_name"
        v-model="fieldDataCheckbox.field_value"
        v-validate="fieldDataCheckbox.rules"
        v-bind:class="{ 'custom-control-input': false,
          'error': errors.has(fieldDataCheckbox.field_name) }"> -->
        <!-- <label :for="fieldDataCheckbox.field_name" class="custom-control-label">{{ fieldDataCheckbox.label }}</label><br/> -->
        <input
        type="checkbox"
        :disabled="(!!showDisabled(fieldDataCheckbox))"
        :ref="fieldDataCheckbox.field_name"
        :id="fieldDataCheckbox.field_name"
        :name="fieldDataCheckbox.field_name"
        v-model="fieldDataCheckbox.field_value"
        v-validate="fieldDataCheckbox.rules"
        v-bind:class="{ 'custom-control-input': true,
          'error': errors.has(fieldDataCheckbox.field_name) }">

        <label :for="fieldDataCheckbox.field_name" class="custom-control-label">{{ fieldDataCheckbox.label }}</label>
      <input
        v-show="fieldDataText.visible"
        type="text"
        :name="fieldDataText.field_name"
        :id="fieldDataText.field_name"
        :ref="fieldDataText.field_name"
        :aria-describedby="`${fieldDataText.field_name}_describedby`"
        :disabled="(!!showDisabled(fieldDataText))"
        v-bind:class="{ 'form-control': true,
          'error': errors.has(fieldDataText.field_name) }"
        v-model="fieldDataText.field_value"
        v-validate="fieldDataText.rules"
        :placeholder="fieldDataText.placeholder"
        :maxlength="fieldMaxLength()">
    </div>

    <!-- <label
      v-html="fieldDataText.label"
      :for="fieldDataText.field_name"
      :class="(isRequired ? 'field-required' : '')">
    </label> -->

    <div class="input-group" :style="fieldStyles()">
      <field-icon :fieldData="fieldDataText"></field-icon>


      <span v-bind:class="{ 'warning fas fa-exclamation-triangle': errors.has(fieldDataText.field_name) }"></span>
    </div>

    <div class="invalid-feedback d-block">{{ errors.first(fieldDataText.field_name) }}</div>
  </div>
</template>

<script>
/* eslint-disable */
import FieldIcon from '../../presentational/FieldIcon';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldDataText', 'fieldDataCheckbox', 'defaultTextValue'],
  components: { FieldIcon },
  computed: {
    isRequired() {
      return this.fieldDataText.rules && this.fieldDataText.rules.required === true;
    },
  },
  methods: {
    /**
     * Calculates the width of this component based on the data.
     * TODO: Refactor to be more universal rather than only for width.
     */
    fieldStyles() {
      const defaultFieldWidth = '50%';
      const rules = this.fieldDataText.rules || {};
      const fieldWidth = rules.max || rules.digits || null;
      const finalFieldWidth = fieldWidth ? `${fieldWidth + 4}em` : defaultFieldWidth;

      return `width: ${finalFieldWidth}; max-width: 100%;`;
    },
    fieldMaxLength() {
      const rules = this.fieldDataText.rules || {};

      return rules.max || rules.digits || null;
    },
    showDisabled(fieldData) {
      return !fieldData.is_enabled;
    },
    /**
     * The validation message overlaps the interactive form element, so it is cleared
     * once the components containing the element is clicked.
     */
    clearMessages() {
      this.errors.remove(this.fieldDataText.field_name); // Temporarily hide the validation message
    },
  },
  watch: {
    'fieldDataText.field_value': function fieldValue() {
      this.clearMessages();
    },
    /**
     * When the checkbox changes from unchecked to checked, the text field becomes enabled with the carrier's default external ID.
     * When the checkbox changes from checked to unchecked, the text field becomes disabled with blank string
     */
    'fieldDataCheckbox.field_value': function fieldValue(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.fieldDataText.is_enabled = true;
        this.fieldDataText.field_value = this.defaultTextValue;
      } else {
        this.fieldDataText.is_enabled = false;
        this.fieldDataText.field_value = '';
      }
    },
  },
};
</script>
<style scoped>
.form-control{
    width:60% !important;
}
.custom-control-input:checked ~ .custom-control-label::before{
  background-color: #333333;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/interactive/InputCheckboxText.vue?7fadedaf